import React from 'react';

import { Box, Checkbox as MuiCheckbox } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './checkbox.module.css';

import { ReactComponent as DefaultCheckMark } from 'asset/CustomIcons/check.svg';

const Checkbox = ({
    variant,
    size,
    name,
    value,
    CustomCheckMark,
    checked,
    onChange,
    disabled,
    props,
}) => {
    const UncheckedIcon = (
        <Box
            className={clsx(
                styles.uncheckIcon,
                styles[variant],
                styles[size],
                disabled && styles.disabled
            )}
        />
    );

    const CheckedIcon = (
        <Box
            className={clsx(
                styles.checkIcon,
                styles[variant],
                styles[size],
                disabled && checked && styles.strictEnabled
            )}
        >
            {CustomCheckMark ? (
                <CustomCheckMark
                    className={clsx(
                        styles.checkmarkIcon,
                        styles[variant],
                        styles[size],
                        !checked && disabled && styles.disabled
                    )}
                />
            ) : (
                <DefaultCheckMark
                    className={clsx(
                        styles.checkmarkIcon,
                        styles[variant],
                        styles[size],
                        !checked && disabled && styles.disabled
                    )}
                />
            )}
        </Box>
    );

    return (
        <MuiCheckbox
            disableRipple
            className={styles.checkbox}
            checked={checked}
            onChange={onChange}
            icon={UncheckedIcon}
            checkedIcon={CheckedIcon}
            disabled={disabled}
            {...props}
            name={name}
            value={value}
        />
    );
};

Checkbox.defaultProps = {
    variant: 'filled',
    size: 'md',
    checked: false,
};

Checkbox.propTypes = {
    variant: PropTypes.oneOf(['filled', 'outlined']),
    size: PropTypes.oneOf(['sm', 'md']),
    CustomCheckMark: PropTypes.elementType,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    props: PropTypes.object,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    value: PropTypes.bool,
};

export default Checkbox;
